module.exports = __webpack_public_path__ + "static/media/plus-add.eea02928.svg";